// extracted by mini-css-extract-plugin
export default {"main":"Member_main__JfYMs","imgCol":"Member_imgCol__nB8Bm","contentCol":"Member_contentCol__sI0ZE","paraCont":"Member_paraCont__SzZoy"};